import styled, { keyframes } from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'

export const StyledSpinner = styled.div<{ heightClass: HeightClass }>`
  position: relative;

  ${({ theme, heightClass }) => `
    width: ${theme.spinner.sizes[heightClass]}px;
    height: ${theme.spinner.sizes[heightClass]}px;
  `}
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const Svg = styled.svg`
  width: 100%;
  height: 100%;
  fill: ${({ color }) => color ?? '#abbed1'};
  animation: ${rotate} 2s linear infinite;
  vertical-align: baseline;
`
